<template>
  <div id="app">
    <Header />
    <Search @show="getShow" />
    <Screen @show="getShow" />

    <div v-if="show">
      <Intro />
    </div>

    <div v-if="!show">
      <div class="main-box">
        <div v-loading="loading" class="load-box">
          <ul v-if="!loading" class="main-list">
            <li v-for="(item, index) in list.slice(0, size)" :key="index">
              <el-link :href="item.body" target="_blank" :underline="false">
                <img v-if="item.image" :src="item.image" lazy />
				<div v-else class="image-container">
					<img src="https://www.100ec.cn/Public/home/images/wjs_bg.jpg" alt="" />
					<div  class="text-overlay">{{item.title}}</div>
				</div>
                <div class="tag-box">
                  <el-tag>{{ item.dname }}</el-tag>
                  <p>
                    <i class="el-icon-time" style="margin-right: 5px"></i
                    >{{ item.dtime.slice(0, 10) }}
                  </p>
                </div>
              </el-link>
            </li>
          </ul>

          <el-empty
            v-if="list.length === 0"
            description="暂无报告"
            :image-size="200"
          ></el-empty>
        </div>

        <div
          v-if="list.length != 0 && size < list.length"
          class="more-box"
          @click="getMore()"
        >
          <el-divider>
            <span>查看更多</span>
          </el-divider>
        </div>
      </div>
    </div>

    <Suspension />

    <Footer />
  </div>
</template>

<script>
import Header from "./views/Header.vue";
import Search from "./views/Search.vue";
import Intro from "./views/Intro.vue";
import Screen from "./views/Screen.vue";
// import Main from './views/Main.vue'
import Suspension from "./views/Suspension.vue";
import Footer from "./views/Footer.vue";
import { getProject } from './api'
import { eventBus } from './main'
export default {
  components: {
    Header,
    Search,
    Intro,
    Screen,
    // Main,
    Suspension,
    Footer,
  },
  data() {
    return {
      show: true,
      loading: true,
      params: {
        p: 1,
        name: "报告类",
        title: "",
      },
      size: 15,
      allList: [],
      list: [],
      keywords: "",
      industry: [],
      type: [],
      year: [],
    };
  },
  created() {
    getProject(this.params).then((res) => {
      res.list.forEach((item) => {
        if (item.dname != "财报解读") {
          this.allList.push(item);
        }
      });
      this.allList.forEach((item) => {
        if (item.keywords === null) {
          item.keywords = "";
        }
        if (item.body.includes("hgsc_")) {
          item.dtime = "2018-05-10 17:41:50";
        }
      });
      this.list = this.allList;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    });

    // 搜索
    eventBus.$on("search", (keywords) => {
      this.keywords = keywords;
      this.getSearch();
    });

    // 行业
    eventBus.$on("checkIndustry", (industry) => {
      this.industry = industry;
      this.getSearch();
    });

    // 类型
    eventBus.$on("checkType", (type) => {
      this.type = type;
      this.getSearch();
    });

    // 年份
    eventBus.$on("checkYear", (year) => {
      this.year = year;
      this.getSearch();
    });
  },
  methods: {
    getShow(bool) {
      this.show = bool;
    },
    // 从总数据中获取搜索结果
    getSearch() {
      this.loading = true;
      this.size = 15;
      let arr = [];
      // 如果搜索关键词不为空
      if (this.keywords != "") {
        this.allList.forEach((item) => {
          if (
            (item.keywords != null && item.keywords.includes(this.keywords)) ||
            item.title.includes(this.keywords)
          ) {
            arr.push(item);
          }
        });
      } else {
        arr = this.allList;
      }

      this.getScreen(arr);
    },

    // 筛选器
    getScreen(arr) {
      this.list = [];
      // arr.forEach(item => {
      //     if(
      //         (this.industry.length === 0 ? true : this.industry.includes(item.dname))
      //         &&
      //         (this.year.length === 0 ? true : this.year.includes(item.title.slice(1, 5)))
      //     ) {
      //         this.list.push(item)
      //     }
      // })

      arr.forEach((item) => {
        if (
          (this.industry.length === 0
            ? true
            : this.industry.find((n) => {
                // console.log(n);
                if (item.title.includes(n) || item.keywords.includes(n)) {
                  return true;
                }
              }) != undefined) &&
          (this.type.length === 0
            ? true
            : this.type.find((n) => {
                if (item.title.includes(n) || item.keywords.includes(n)) {
                  return true;
                }
              }) != undefined) &&
          (this.year.length === 0
            ? true
            : this.year.includes(item.title.slice(1, 5)))
        ) {
          this.list.push(item);
        }
      });

      this.list = this.list.sort(
        (a, b) => +new Date(b.dtime) - +new Date(a.dtime)
      );

      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },

    getMore() {
      this.size += 15;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  color: #2c3e50;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

body {
  background: #fafafb;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
  transition: all 0.3s ease-in-out;
}

img {
  display: block;
}

textarea {
  outline: none;
}

input {
  border: none;
}
.main-box {
  max-width: 1200px;
  margin: auto auto 40px;
  background: #fff;
  padding: 10px 0 20px;
}

.load-box {
  min-height: 240px;
}

.main-list {
  display: flex;
  flex-wrap: wrap;
}

.main-list li {
  flex: 0 0 20%;
  opacity: 0.85;
  padding: 10px;
  transition: all 0.3s ease-in-out;
}

.main-list li:hover {
  opacity: 1;
}

.main-list li img {
  width: 100%;
  border-radius: 4px;
}

.main-list .tag-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
}

.main-list li p {
  font-size: 12px;
  color: #a8b4bf;
}
.image-container {
  position: relative;
  display: inline-block; /* 或其他适合的显示类型 */
}
.text-overlay {
  position: absolute;
  font-weight: 600;
  top: 3%; /* 垂直居中 */
  /* left: 50%; /* 水平居中 */ 
  /* transform: translate(-50%, -50%); 调整位置 */
  color: white; /* 文字颜色 */
  /* background-color: rgba(0, 0, 0, 0.5); /* 背景色，可调透明度 */ 
  padding: 10px; /* 内边距 */
}

.more-box {
  display: flex;
  justify-content: center;
  width: 30%;
  margin: auto;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.more-box:hover .el-divider {
  background-color: dodgerblue;
  transition: all 0.3s ease-in-out;
}

.more-box:hover .el-icon-arrow-down:before {
  font-size: 20px;
  font-weight: bold;
  color: dodgerblue;
}

.more-box span {
  color: #dcdfe6;
  transition: all 0.3s ease-in-out;
}

.more-box:hover span {
  color: dodgerblue;
}

@media (max-width: 1200px) {
  .main-list li {
    flex: 0 0 50%;
    opacity: 1;
  }

  .more-box {
    width: 90%;
  }
}
</style>
